import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TopBannerWidgetConfigurationPageSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="text" width={220} height={28} />
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="text" width="80%" height={20} />

      <Styles.Section>
        <Skeleton variant="text" width={180} height={24} />
        <Styles.ColorsGrid>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.ColorsGrid>
      </Styles.Section>

      <Styles.CustomTextBlock>
        <Skeleton variant="text" width={180} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={220} height={20} />
        </Styles.ToggleRow>
        <Styles.TabsRow>
          <Skeleton variant="rounded" width={80} height={32} />
          <Skeleton variant="rounded" width={80} height={32} />
        </Styles.TabsRow>
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.CustomTextBlock>

      <Styles.Section>
        <Skeleton variant="text" width={140} height={24} />
        <Skeleton variant="rounded" width="100%" height={120} />
      </Styles.Section>

      <Skeleton variant="rounded" width="100%" height={120} />
    </Styles.Container>
  )
}

export default TopBannerWidgetConfigurationPageSkeleton
